import { NgModule } from '@angular/core';
import { KeysPipe } from './keys-pipe';
import { ObjectKeysPipe } from './object-keys-pipe';
import { CustomDatePipe } from './custom-date-pipe';

@NgModule({
  declarations: [
    KeysPipe,
    ObjectKeysPipe,
    CustomDatePipe
  ],
  exports: [
    KeysPipe,
    ObjectKeysPipe,
    CustomDatePipe
  ]
})

export class PipesModule {}
